import { MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';

import Tasks from 'APP/Tasks';
import { RouterState } from 'APP/router/constants';

interface IDeepLinkRendererPresenterParams {
  link: string;
  groupId: string;
}

interface IDeepLinkRendererPresenter {
  onClick(event: MouseEvent<HTMLAnchorElement>): void;
}

export const useDeepLinkRendererPresenter = (
  data: IDeepLinkRendererPresenterParams
): IDeepLinkRendererPresenter => {
  const { link, groupId } = data;
  const navigateTo = useNavigate();

  const presenter: IDeepLinkRendererPresenter = {
    onClick(event: MouseEvent<HTMLAnchorElement>): void {
      event.preventDefault();

      const state: Record<string, boolean> = {};
      if (groupId) {
        state[RouterState.hasGoBack] = true;
      }

      Tasks.deeplinks.handleDeepLink({ link, navigateTo, state });
    },
  };

  return presenter;
};
